<template>
  <div class="my-4 flex w-full justify-between">
    <div
      v-for="index in localLength"
      :key="index"
      class=""
      :class="
        index !== localLength ? 'flex w-full items-center' : 'flex items-center'
      "
    >
      <span
        class="progressDot relative z-10"
        :class="[
          index === localCurrentStep
            ? 'pulse-yellow'
            : index < currentStep
              ? 'active'
              : '',
        ]"
      />
      <!-- <span
        v-if="index !== length"
        class="progressLine"
        :class="index <= currentStep && 'active'"
      ></span> -->
      <span
        v-if="index !== length"
        class="progressLine"
        :class="[
          index < currentStep && (index != localCurrentStep || index == 1)
            ? 'active'
            : '',
        ]"
      >
        <span
          v-if="index !== length"
          class="progressLineToAnimate"
          :class="index == currentStep - 1 && 'animate'"
        >
          <!-- <span
            class="progressDotToAnimate"
            :class="index == currentStep - 1 && 'animate'"
          >
          </span> -->
          <!-- <span
            class="progressDotToAnimate"
            :class="[localCurrentStep == currentStep - 1 ? 'animate' : index == currentStep ? 'unanimate' : '']"
          >
          </span> -->
          <span
            class="progressDotToAnimate"
            :class="[
              index == localCurrentStep && currentStep >= localCurrentStep
                ? 'animate'
                : '',
            ]"
          />
        </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressIndicator',
  props: {
    currentStep: { type: Number, default: 0 },
    length: { type: Number, default: 9 },
    autoSkipStageSix: { type: Boolean, default: false },
    autoSkipStageSeven: { type: Boolean, default: false },
    autoSkipStageEight: { type: Boolean, default: false },
    autoSkipStageNine: { type: Boolean, default: false },
  },
  data() {
    return {
      localCurrentStep: 0,
    };
  },
  computed: {
    localLength() {
      let count = 0;
      if (this.autoSkipStageSix == true) count++;
      if (this.autoSkipStageSeven == true) count++;
      if (this.autoSkipStageEight == true) count++;
      if (this.autoSkipStageNine == true) count++;
      return this.length - count;
    },
    activeStep() {
      return this.$store.state.formRoutes?.activeStep || null;
    },
  },
  watch: {
    activeStep(newVal, oldVal) {
      // Note: Timeout length should be tied to progressLineToAnimate transition length (in ms)
      let self = this;
      if (newVal?.step < oldVal?.step) {
        self.localCurrentStep = self.adjustStepCount(newVal?.step);
      } else {
        setTimeout(function () {
          self.localCurrentStep = self.adjustStepCount(newVal?.step);
        }, 500);
      }
    },
  },
  mounted() {
    this.localCurrentStep = this.currentStep;
  },
  methods: {
    adjustStepCount(stepNumber) {
      let count = 0;
      if (stepNumber >= 6 && this.autoSkipStageSix == true) count++;
      if (stepNumber >= 7 && this.autoSkipStageSeven == true) count++;
      if (stepNumber >= 8 && this.autoSkipStageEight == true) count++;
      if (stepNumber >= 9 && this.autoSkipStageNine == true) count++;
      return stepNumber - count;
    },
  },
};
</script>

<style scoped>
.progressDot {
  @apply flex h-3 w-3 rounded-full bg-placeholder-gray;
  min-width: 12px;
}

.progressLine {
  @apply relative flex w-full bg-placeholder-gray;
  height: 2px;
}
.progressLineToAnimate {
  @apply relative flex bg-yellow-500;
  /* width: calc(100% + 4px); */
  /* right: -4px; */
  width: 100%;
  height: 2px;
  max-width: 0px !important;
  transition: max-width 0.5s ease-in-out;
}

.progressLineToAnimate.animate {
  /* max-width: calc(100% + 4px) !important; */
  max-width: 100% !important;
}

.progressDotToAnimate {
  @apply rounded-full bg-transparent;
  position: absolute;
  right: 0px;
  top: -1px;
  bottom: -1px;
  width: 4px;
}
/* .progressDotToAnimate.animate { */
.progressDotToAnimate.animate,
.progressDotToAnimate.unanimate {
  @apply bg-yellow-600;
  animation: pulse-yellow 0.25s linear;
}

.active {
  @apply bg-yellow-500;
  box-shadow: 0px 5px 10px rgba(248, 198, 23, 0.3);
}
.progressDot.pulse-yellow {
  @apply bg-yellow-500;
  box-shadow: 0px 5px 10px rgba(248, 198, 23, 0.3);
  transition: all 0.5s ease-in-out;
}
</style>
